import React, { useContext } from 'react'
import styles from './round.m.scss'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/icon.css'
import { Candidate } from '../candidate/index'
import { Round as RoundInterface } from 'types/Round'
import messages from './round.locales.yml'
import IntlMessageFormat from 'intl-messageformat'
import { LocaleContext } from 'contexts/locale'

export function Round({
  round,
  castVotes,
  absoluteMajority,
  candidates
}: RoundInterface) {
  // Set up the localisation
  const locale = useContext(LocaleContext)
  const localisedMessages = messages[locale]
  const roundTitleFormatter = new IntlMessageFormat(
    localisedMessages.roundTitle,
    locale + '-CH'
  )
  const numberFormatter = new Intl.NumberFormat(locale + '-CH')

  // Sort the candidates according to the votes they received
  candidates.sort((a, b) => {
    return b.receivedVotes - a.receivedVotes
  })

  return (
    <div className={styles.round}>
      <table className={styles.table}>
        <thead>
          <tr>
            <th className={styles.avatarHeader} />
            <th className={styles.roundTitle}>
              <h3 className={styles.header}>
                {roundTitleFormatter.format({ roundNumber: round })}
              </h3>
            </th>
            <th className={styles.absoluteMajorityCell}>
              <div
                className={styles.absoluteMajority}
                style={{
                  left: (absoluteMajority / castVotes) * 100 + '%'
                }}
              >
                <div className='label'>
                  <span className='mobile hidden'>
                    {localisedMessages.absoluteMajorityLabel}:
                  </span>{' '}
                  <strong>{numberFormatter.format(absoluteMajority)}</strong>
                </div>
                <svg
                  className={styles.svg}
                  width='10px'
                  height='1000px'
                  preserveAspectRatio='xMidYMin slice'
                >
                  <line
                    className={styles.absoluteMajorityLine}
                    x1={5}
                    y1={0}
                    x2={5}
                    y2={1000}
                  />
                </svg>
              </div>
            </th>
          </tr>
        </thead>
        <tbody>
          {candidates.map((candidate, index) => {
            return (
              <Candidate
                key={`${round}-${index}-${candidate.candidateName}`}
                {...candidate}
                castVotes={castVotes}
              />
            )
          })}
        </tbody>
      </table>
    </div>
  )
}
